import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-footer',
  imports: [CommonModule, RouterLink],
  templateUrl: './footer.html',
  styleUrl: './footer.css'
})
export class Footer {
  currentYear = new Date().getFullYear();

  services = [
    { path: '/performance-marketing', label: 'Performance Marketing' },
    { path: '/cloud-compliance', label: 'Cloud Audits & Compliance' },
    { path: '/devops', label: 'DevOps & Automation' },
    { path: '/messaging', label: 'Messaging Services' }
  ];

  quickLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About Us' },
    { path: '/contact', label: 'Contact' }
  ];

  legalLinks = [
    { path: '/privacy-policy', label: 'Privacy Policy' },
    { path: '/terms', label: 'Terms & Conditions' }
  ];
}
